var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_PRODUCTS_REQUEST, FETCH_UPDATE_PRODUCTS_REQUEST, fetchProductsSuccess, fetchProductsFailure, updateProductsSuccess, updateProductsFailure, } from "../../actions";
import APILocal from "../../../utils/APILocal";
const onFetchProducts = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APILocal.get(`/order/product/list?channelIdList=all&pageSize=${action.payload.pageSize}&startOffset=${action.payload.startOffset}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
const onUpdateProducts = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            console.log(`Update product request: ${JSON.stringify(action.payload)}`);
            APILocal.put(`/order/product/`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchProductWorker(action) {
    try {
        const data = yield call(onFetchProducts, action);
        yield put(fetchProductsSuccess(data));
    }
    catch (error) {
        yield put(fetchProductsFailure(error));
    }
}
function* updateProductWorker(action) {
    try {
        const data = yield call(onUpdateProducts, action);
        yield put(updateProductsSuccess(data));
    }
    catch (error) {
        yield put(updateProductsFailure(error));
    }
}
export function* watchProductsData() {
    yield takeLatest(FETCH_PRODUCTS_REQUEST, fetchProductWorker);
    yield takeLatest(FETCH_UPDATE_PRODUCTS_REQUEST, updateProductWorker);
}
